import CustomMainVerify from '@comp/CustomVerify';
import CustomFailed from '@root/components/CustomFailed';
import CustomSuccess from '@root/components/CustomSuccess';
import {
  formVerifyData,
  getEurasia36ContentData
} from '@root/constants/formData';
import {
  eurasia36Verify,
  eurasia36VerifyFailed,
  eurasia36VerifySuccess
} from '@root/constants/paths';

const { main } = getEurasia36ContentData();

export const getEurasia36VerifyRoutes = () => [
  {
    path: eurasia36Verify(),
    element: (
      <CustomMainVerify
        mainContent={main}
        formData={formVerifyData}
        redirectPaths={{
          success: eurasia36VerifySuccess,
          failed: eurasia36VerifyFailed
        }}
      />
    )
  },
  {
    path: eurasia36VerifySuccess(),
    element: <CustomSuccess />
  },
  {
    path: eurasia36VerifyFailed(),
    element: <CustomFailed />
  }
];
